/**
 * The Rotate room row: two buttons that turn a room a quarter turn left or
 * right in its own data (the edges roll one notch, width and length swap).
 * Shared by the room editor's room fields and the assembler's selected-room
 * inspector, which each apply the turn to their own state.
 */

import { css } from '@emotion/react';
import { FIELD_ROW_STYLE, ICON_BUTTON_STYLE } from './chrome';

const TURN_BUTTONS_STYLE = css`
  label: TURN_BUTTONS_STYLE;
  display: inline-flex; gap: 6px;
`;

const TURN_BUTTON_STYLE = css`
  label: TURN_BUTTON_STYLE;
  width: 43px; height: 35px;
`;

/** A quarter-turn arrow; `counterClockwise` draws the left turn. */
function TurnIcon({ counterClockwise = false }: { counterClockwise?: boolean }): React.JSX.Element {
  return (
    <svg viewBox='0 0 16 16' width='16' height='16' aria-hidden='true'>
      <path
        d={counterClockwise ? 'M4 6a5 5 0 1 1 -1 5M4 2v4h4' : 'M12 6a5 5 0 1 0 1 5M12 2v4h-4'}
        fill='none'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

/** `onRotate` receives the quarter turns to apply: -1 for left, 1 for right. */
export function RotateRoomRow({ onRotate }: { onRotate: (quarterTurns: number) => void }): React.JSX.Element {
  return (
    <div css={FIELD_ROW_STYLE}>
      <label>Rotate room</label>
      <span css={TURN_BUTTONS_STYLE}>
        <button
          type='button'
          css={[ICON_BUTTON_STYLE, TURN_BUTTON_STYLE]}
          data-act='rotate-room-left'
          aria-label='Rotate room left'
          title='Turn the room a quarter turn left'
          onClick={() => onRotate(-1)}
        >
          <TurnIcon counterClockwise />
        </button>
        <button
          type='button'
          css={[ICON_BUTTON_STYLE, TURN_BUTTON_STYLE]}
          data-act='rotate-room-right'
          aria-label='Rotate room right'
          title='Turn the room a quarter turn right'
          onClick={() => onRotate(1)}
        >
          <TurnIcon />
        </button>
      </span>
    </div>
  );
}
